import axios, { AxiosResponse } from 'axios'
import { getAppBaseUrl } from './api'

const baseURL = getAppBaseUrl()

export const getWhiteLabelSites = (): Promise<AxiosResponse> => {
    return axios.get(`${baseURL}/whitelabel/sites`)
}

export const getWhiteLabelSite = (siteId?: string): Promise<AxiosResponse> => {
    const suffix = siteId ? `?site_id=${encodeURIComponent(siteId)}` : ''
    return axios.get(`${baseURL}/whitelabel/site${suffix}`)
}

export const saveWhiteLabelSite = (data: object): Promise<AxiosResponse> => {
    return axios.post(`${baseURL}/whitelabel/site`, data)
}

export const saveWhiteLabelPersona = (data: object): Promise<AxiosResponse> => {
    return axios.post(`${baseURL}/whitelabel/site/persona`, data)
}

export const removeWhiteLabelPersona = (site_id: string, agent_key: string): Promise<AxiosResponse> => {
    return axios.post(`${baseURL}/whitelabel/site/persona/remove`, { site_id, agent_key })
}

export default {
    getWhiteLabelSites,
    getWhiteLabelSite,
    saveWhiteLabelSite,
    saveWhiteLabelPersona,
    removeWhiteLabelPersona
}
